///srrirrr====================nulll 
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    console.log("CartDrawer constructor");
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();


    this.querySelector('#CartDrawer-Checkout')?.addEventListener('click', (event) => {
      if (localStorage.getItem('pincode') === null) {
        event.preventDefault();
        event.stopImmediatePropagation();
       document.querySelector('pincode-checker').setAttribute('isCheckout',true);

        this.openPincodeChecker();
       
      }
    });

  }

  openPincodeChecker() {

     const container = document.querySelector('pincode-checker');
        if (window.innerWidth < 990) {
          container.classList.add('active-pincode');
          document.querySelector('.pincode-open svg').classList.add('rotated');

        }
        if (window.innerWidth > 989) {
          const parentElement = document.querySelector('#pincode-checker-ele .header-pincode-container');
          parentElement.classList.add('desktop-pincode-popup');
          document.querySelector('.header__icons .header-pincode').classList.add('d-none');
        }
        container.querySelectorAll('p').forEach(elem => elem.classList.add('hidden'));
        container.querySelector('input').value = '';

  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
     
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });
    //freePdp();
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      //console.log("open drawer");
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }
   

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    //document.body.removeEventListener('click', this.handleBodyClick); 
  }
  /* handleBodyClick = (event) => {
  
    if (!this.contains(event.target)) {
      this.close(); 
    }
  } */
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, productCard) {

    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    document.querySelector('quantity-input').updateBubbleIcon(false);
    
    if(productCard){
      if (productCard.closest('marmeto-product-card')) {
        const productId = productCard.closest('marmeto-product-card').getAttribute('id');
        const update = new Event(`update-card--${productId}`);
        document.dispatchEvent(update)
      }
      if (productCard.closest('main-product-button')) {
        const productId = productCard.closest('main-product-button').getAttribute('data-id');
        const ProductUpdate = new Event(`main-product--${productId}`);
        document.dispatchEvent(ProductUpdate);
      }
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.cartObject = JSON.parse(this.querySelector('.cart-object[type="application/json"]')?.textContent);
      
      if (this.cartObject.item_count === 1) {
        //console.log("add to cart...");
        this.open();
        let dc = document.querySelector(".discount-coupon-code:not(.hidden)")?.innerHTML || null;
        console.log("dc>>>>>>",dc);
        // freePdp(dc);
      }
      
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}



customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

if (window.jQuery || window.$) {
  $(document).on('change','.quantity__input', function(){
    freePdp()
  });
}

// offercheck api function
function freePdp(discountCode = null) {
    console.log("discountCode>>>>",discountCode);
    let raw2 = getUpdatedRawOBJ(discountCode);
    console.log("raw2", raw2);
    var settings = {
        "url": "https://srisridiscounts.srisritattva.com/offerchecker",
        "method": "POST",
        "timeout": 0,
        "headers": {
            "Content-Type": "application/json"
        },
        "async": false,
        "data": JSON.stringify(raw2)
    };

    $.ajax(settings).done(function(response, textStatus, xhr) {
        console.log("offerchecker >>>> response", response);
        if (xhr.status === 200) {
          //showLoadingMessage();
            //console.log("status request done....", textStatus);
            if (response) {
              /* if (response.AffliateCoupon === false) {
                //console.log("false value get....");
                let discountCodeVal = localStorage.getItem('discountCode');
            } */
              freeproductAddtoCart(response);
            } else {
              //wrong discount code..
              let wrongDiscount = false;
              if(discountCode) wrongDiscount = true;
              //console.log("wrongDiscount",wrongDiscount);
              removePdp(localStorage.getItem("freeProduct"),wrongDiscount);
            }
        }
      
    }).fail(function(xhr, status, error) {
        //console.error("Error in offerchecker request:", error);
    });
}
//dynamic array..
function getUpdatedRawOBJ(discountCode = null){
  
  var cost2 = {
    "subtotalAmount": {
      "amount": document.querySelector("cart-drawer-items").dataset.totalPrice,
      "currencyCode": document.querySelector("cart-drawer-items").dataset.currency
    },
    "totalAmount": {
      "amount": document.querySelector("cart-drawer-items").dataset.totalPrice,
      "currencyCode": document.querySelector("cart-drawer-items").dataset.currency
    }
  };
  var lineitems = [];
  var cartItems = document.querySelectorAll(".cart-item");
 // console.log("Items==>",cartItems)
  cartItems.forEach(function(item) {
  var itemId = item.getAttribute("data-id");
  var itemprice = item.getAttribute("data-price");
  var itemqty = item.getAttribute("data-qty");
  var itecrcode = item.getAttribute("data-code");
  var collectionIDAttr = item.getAttribute('data-coll-id');
  
  var collectionIDs = collectionIDAttr ? collectionIDAttr.split(',') : [];

  var attributes = collectionIDs.map(function(collectionID) {
    return collectionID !== '' ? "gid://shopify/Collection/" + collectionID : null;
  }).filter(Boolean);
  
  var formattedAttributes = {
    "value": attributes
  };

    lineitems.push({
      "quantity": parseInt(itemqty),
      "attribute": {
        "value": attributes,
      },
      "merchandise": {
        "id": "gid://shopify/ProductVariant/" + itemId
      },
      "cost": {
        "amountPerQuantity": {
          "amount": itemprice,
          "currencyCode": itecrcode
        }
      }
    });
  });

  var currentDate = new Date().toISOString().slice(0, 10);
  // Create an object with the current date
  var localTime2 = {
    "date": currentDate
  };
 var giftcartcodenew =  localStorage.getItem("discountCode",discountCode);
  const raw2 = {
    "cart": {
      "giftcartcode": giftcartcodenew,
      "cost": cost2,
      "lines": lineitems
    },
    "shop": {
      "localTime": localTime2 
    }
  };
  console.log("update raw",raw2);
  //match giftcartcode
  //console.log("giftcartcode",giftcartcode);
  if(giftcartcodenew == null || giftcartcodenew == ""){
    delete raw2["cart"]["giftcartcode"];
  }
  return raw2;
}
// getUpdatedRawOBJ -- END

//add to cart logic
function freeproductAddtoCart(response) {
  console.log("responseOBJ",response);
  
  let offer = response.offer;
  if(offer != null){
      let variantId = offer ? offer.variants[0].id : null;
   // Replace the 'gid://shopify/ProductVariant/' part of the id
  let offerProId = variantId.replace('gid://shopify/ProductVariant/', '');
 // let offerProId = response.variants[0].id.replace('gid://shopify/ProductVariant/', '');
  //console.log("offerProId",offerProId);
  let oldOfferProId = localStorage.getItem("freeProduct");
  if(document.querySelector(`cart-drawer-items .cart-item[data-id="${offerProId}"]`) == null){
  
    if(oldOfferProId && oldOfferProId != offerProId){
      //console.log("remove old FREE product");
      removePdp(oldOfferProId);
    }
    //console.log("inside condition");
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: {
          quantity: 1,
          id: offerProId,
          sections: document.querySelector("cart-drawer-items").getSectionsToRender().map((section) => section.section),
          section_url: window.location.pathname
      },
      dataType: 'json',
      success: function(data) {
        //console.log('Product added to cart:', data);
        document.querySelector("cart-drawer").renderContents(data);
        localStorage.setItem("freeProduct",offerProId);
      }
    });
  }

    // let discountCode = localStorage.getItem("discountCode");
    let discountCode = document.querySelector(".discount-coupon-code:not(.hidden)")?.innerHTML || null;
    // setCookie('discount_code', discountCode, 1); 
    let updatedRaw = getUpdatedRawOBJ(discountCode);
    console.log("updatedRaw", updatedRaw);
    // localStorage.removeItem("discountCode");
    var settings = {
      "url": "https://srisridiscounts.srisritattva.com/cartcheck",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json"
      },
      "async": false,
      "data": JSON.stringify(updatedRaw)
    };
  
    $.ajax(settings).done(function (response) {
  
      console.log('response1111',response);
      
      //console.log("cartcheck Response received:", response);
      if (!offer) return false;
 
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        dataType: 'json',
        async: false,
        data: {
          attributes: {
            new_key: null,
            CART_DISCOUNT: JSON.stringify(response.discounts)
          },
          sections: document.querySelector("cart-drawer-items").getSectionsToRender().map((section) => section.section),
          section_url: window.location.pathname
        },
        success: function(response) {
          console.log('Attribute Update', response);
          document.querySelector("cart-drawer").renderContents(response);
        },
        error: function(xhr, status, error) {
          console.error('Error updating cart', error);
        }
      });
    })
    .fail(function(xhr, status, error) {
      console.error("Error in cartcheck request:", error);
    });
  }else{
    console.log("else inside...@!");
    let discountCode = document.querySelector(".discount-coupon-code:not(.hidden)")?.innerHTML || null;
    let updatedRaw = getUpdatedRawOBJ(discountCode);
    console.log("updatedRaw", updatedRaw);
    // localStorage.removeItem("discountCode");
    var settings = {
      "url": "https://srisridiscounts.srisritattva.com/cartcheck",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json"
      },
      "async": false,
      "data": JSON.stringify(updatedRaw)
    };
  
    $.ajax(settings).done(function (response) {
    console.log('offer null');  
    var discont_available;
      if(response.discounts && offer == null){
        discont_available = JSON.stringify(response.discounts);
      }else{
        discont_available = "";
      }
    $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        dataType: 'json',
        async: false,
        data: {
          attributes: {
            new_key: null,
            CART_DISCOUNT: discont_available
          },
           sections: document.querySelector("cart-drawer-items").getSectionsToRender().map((section) => section.section),
          section_url: window.location.pathname
        },
        success: function(response) {
          console.log('Attribute Update', response);
          document.querySelector("cart-drawer").renderContents(response);
           //document.getElementById("loadingMessage").classList.add("hidden");
        },
        error: function(xhr, status, error) {
          console.error('Error updating cart', error);
        }
      });
    }) 
      .fail(function(xhr, status, error) {
      console.error("Error in cartcheck request:", error);
    });
  }
  
}
//remove free product
function removePdp(freeProId, wrongDiscount = false) {
  //console.log("removePDP wrongDiscount",wrongDiscount);

  // if wrong code then remove remove cart attr
  if(wrongDiscount){
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      async: false,
      data: {
        attributes: {
          "_discount_code": ""
        },
        sections: document.querySelector("cart-drawer-items").getSectionsToRender().map((section) => section.section),
        section_url: window.location.pathname
      },
      dataType: 'json',
      success: function (data) {
        console.log('Attr removed: from removePDP', data);
        if(!document.querySelector(`cart-drawer-items .cart-item[data-id="${freeProId}"]`)){
          document.querySelector("cart-drawer").renderContents(data);
        }
      },
      error: function(xhr, status, error) {
        //console.error('Error removing product from cart:', error);
      }
    });
  }
  
/*   if(document.querySelector(`cart-drawer-items .cart-item[data-id="${freeProId}"]`)){
   // console.log("freeProId remove...", freeProId); 
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      async: false,
      data: {
        quantity: 0,
        id: freeProId, // Corrected variable name
        sections: document.querySelector("cart-drawer-items").getSectionsToRender().map((section) => section.section),
        section_url: window.location.pathname
      },
      dataType: 'json',
      success: function (data) {
        //console.log('Product removed from cart:', data);
        document.querySelector("cart-drawer").renderContents(data);
        localStorage.removeItem("freeProduct");
        //wrong code error msg
        if(wrongDiscount && document.querySelector("[data-discount-code-error]")) document.querySelector("[data-discount-code-error]").classList.remove("hidden");
      },
      error: function(xhr, status, error) {
        //console.error('Error removing product from cart:', error);
      }
    }); 
  }*/
}

if (window.jQuery || window.$) {
  $(document).ready(function(){
    freePdp();
    // applyDiscount btn click event
    $(document).on("click","#cartDrawer-coupon-code #applyDiscountBtn",function(){
      
      //loging msg using css
      document.getElementById("loadingMessage").classList.remove("hidden");
      // return false;
      let discountCode = document.getElementById('discountInput').value;
      console.log('Discount code entered:', discountCode);
      localStorage.setItem("discountCode",discountCode);
      //setCookie('discount_code', discountCode);    
      //document.cookie = "discount_code=" + discountCode ;
      document.cookie = "discount_code=" + discountCode + "; path=/;";

    // const discountUrl = `https://www.srisritattva.com/discount/${discountCode}?redirect=%2Fcheckout`; 
    //  console.log("discountUrl=======>>>>",discountUrl);
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        // async: false,
        data: {
          attributes: {
            "_discount_code": discountCode
          },
          sections: document.querySelector("cart-drawer-items").getSectionsToRender().map((section) => section.section),
          section_url: window.location.pathname
        },
        dataType: 'json',
        success: function (data) {
          //console.log('Attr added:', data);
            if (data && data.attributes && data.attributes["_discount_code"] !== null) {
              console.log('Coupon code applied successfully');
              freePdp(discountCode);
            }
        },
        error: function(xhr, status, error) {
          //console.error('Error removing product from cart:', error);
        }
      });
    });

    // data-remove-discount-code
    $(document).on("click","[data-remove-discount-code]",function(){
          console.log('remove discount clicked');
    // document.cookie = 'discount_validation=false';
      //document.getElementById("loadingMessage").classList.remove("hidden");
      let discountCode = document.querySelector(".discount-coupon-code:not(.hidden)")?.innerHTML || null;
        console.log('remove discount');
        if(discountCode){
        localStorage.removeItem("discountCode",discountCode);
      document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          // async: false,
          data: {
            attributes: {
              "_discount_code": ""
            },
            sections: document.querySelector("cart-drawer-items").getSectionsToRender().map((section) => section.section),
            section_url: window.location.pathname
          },
          dataType: 'json',
          success: function (data) {
            //console.log('Attr removed:', data);
            document.querySelector("cart-drawer").renderContents(data);
            // call function without discount code
            freePdp();
          },
          error: function(xhr, status, error) {
            //console.error('Error removing product from cart:', error);
          }
        });
      }
    });
  });
}
